/**
 * Pálinka főzési eljárás
 */
export type BrewingProcess = 'BAKE_IT' | 'COLUMNAR' | 'OTHER';

export const BrewingProcess = {
  BakeIt: 'BAKE_IT' as BrewingProcess,
  Columnar: 'COLUMNAR' as BrewingProcess,
  Other: 'OTHER' as BrewingProcess,
};
